import React from 'react'
import { View } from "react-native"

export const LinearGradient = ({ colors, style, children, ...props }: any) => {
  const backgroundColor = colors && colors.length > 0 ? colors[0] : "transparent"

  return (
    <View style={[{ backgroundColor }, style]} {...props}>
      {children}
    </View>
  )
}

export default LinearGradient
